import {
  GET_PRODUCT_SUCCESS,
  GET_PRODUCT_FAILURE,
  SET_PRODUCT_SUCCESS,
  SET_PRODUCT_FAILURE,
  PUT_PRODUCT_SUCCESS,
  PUT_PRODUCT_FAILURE,
  PUT_PRODUCT_REQUEST,
  DELETE_PRODUCT_SUCCESS,
  CONSIDER_REVENUE_SUCCESS,
  DOWNLOAD_ANALYTICAL_PRODUCTS_SUCCESS,
  PRODUCTS_CLEAN,
} from "../../../constants/actionTypes";
const INITIAL_STATE = {
  list: [],
  data: {},
  status: null,
  onRequest: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_PRODUCT_SUCCESS:
      return {
        ...state,
        data: action.payload,
      };
    case GET_PRODUCT_FAILURE:
      return {
        ...state,
        status: 400,
      };
    case SET_PRODUCT_SUCCESS:
      return {
        ...state,
        status: action.payload?.StatusCode,
      };
    case SET_PRODUCT_FAILURE:
      return {
        ...state,
        status: 400,
      };
    case PUT_PRODUCT_SUCCESS:
      return {
        ...state,
        status: action.payload?.StatusCode,
      };
    case PUT_PRODUCT_FAILURE:
      return {
        ...state,
        status: 400,
      };
    case PUT_PRODUCT_REQUEST:
      return {
        ...state,
        onRequest: true,
      };
    case DELETE_PRODUCT_SUCCESS:
      return {
        ...state,
        status: action.payload?.StatusCode,
      };
    case CONSIDER_REVENUE_SUCCESS:
      return {
        ...state,
        data: action.payload,
      };
    case DOWNLOAD_ANALYTICAL_PRODUCTS_SUCCESS:
      return {
        ...state,
        status: action.payload.status,
      };
    case PRODUCTS_CLEAN:
      return {
        ...state,
        data: {},
        status: null,
      };
    default:
      return state;
  }
};
